// @flow
import React from 'react'
import styles from './TableHeader.css'

type TableHeaderProps = {
  type: string,
  fields: Array<Object>
}

export const TableHeader = ({ type, fields }: TableHeaderProps) => {
  let fieldsToShow = []
  switch (type) {
    case 'TWO_NUMBERS':
      fieldsToShow = [
        fields.find(f => f.role === 'id'),
        fields.find(f => f.role === 'name'),
        ...fields.filter(f => f.role === 'value').slice(0, 2)
      ]
      break
    case 'ONE_NUMBER':
    default:
      fieldsToShow = [
        /* fields.find(f => f.role === 'id'), */
        fields.find(f => f.role === 'name'),
        ...fields.filter(f => f.role === 'value').slice(0, 1)
      ]
      break
  }

  // figure out how to hide tableheader without .nrk-sr for accessibility

  return (
    <thead className={styles.tableHeaderHidden}>
      <tr>
        {fieldsToShow.map(f => {
          if (f && f.id && f.name) {
            return (
              <th scope="col" key={f.id || ''}>
                {f.name || ''}
              </th>
            )
          }
          return null
        })}
      </tr>
    </thead>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/Main/Rows/TableHeader.js